import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaAction, ISchemaChild, ISchemaFilter, ISchemaProperty } from "../Schema";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import { NoNullValues, NotEmptyString, ValidateEmail, ValidatePhoneNumber } from "../../../../Validation/Validation";
import { ActionTypes } from "../../../../enums/ActionTypes";
import { ActionStyles } from "../../../../enums/ActionStyles";
import editIcon from "../../../../assets/icons/icon-pen-white.svg"
import SidePanelUsers from "../../layout/SidePanel/layouts/SidePanelUsers";

export const UserSchema: ISchema = {
    displayName: "User",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelUsers data={data} showHeader={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'name',
            displayName: 'Name',
            descriptor: true,
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function,
            validationError: "Name cannot be empty",
            autocomplete: "name",
        } as ISchemaProperty,
        {
            name: 'email',
            displayName: 'Email',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: ValidateEmail as Function,
            validationError: "Please enter valid email",
            autocomplete: "email",
        } as ISchemaProperty,
        {
            name: 'phoneNumber',
            displayName: 'Telephone Number',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: ValidatePhoneNumber as Function,
            validationError: "Please enter valid phone number",
            autocomplete: "tel",
            inputType: "tel",
        } as ISchemaProperty,
        {
            name: 'role',
            displayName: 'Role',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'status',
            displayName: 'Status',
            type: PropertyTypes.status,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'accountRoles',
            displayName: 'Roles & Permissions',
            type: PropertyTypes.accountRoles,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NoNullValues as Function,
            validationError: "User must have a role",
        } as ISchemaProperty,
    ],

    primaryFilter: {
        PropertyName: "User.Name",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.FreeTextContains,
        propertyType: PropertyTypes.string,
        placeHolder: "Enter a user's name / email"
    } as ISchemaFilter,

    filters: [
        {
            PropertyName: "User.Status",
            entityName: EntityNames.userStatuses,
            displayName: "Status",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.int,
            showInTab: true,
            dependsOn: null
        } as ISchemaFilter,
    ],

    children: [
        { entityName: EntityNames.users, displayName: "Accounts", cantView: false, viewType: EntityViewTypes.list, enableFilters: true, navPropertyName: "AccountId" } as ISchemaChild
    ],

    sidePanelActions: [
        {text: "Edit Details", action: ActionTypes.edit, style: ActionStyles.primary, icon: editIcon } as ISchemaAction,
        {text: "Block", action: ActionTypes.block, style: ActionStyles.destructive, icon: undefined } as ISchemaAction,
    ]
}
